import React, {
  useEffect,
} from 'react';

import {
  Grid,
  TextField,
  Container,
  Card,
  CardContent
} from '@mui/material';

import { makeStyles } from '@mui/styles';

import Page from 'src/components/Page';

import { useDispatch, useSelector } from 'react-redux';

import Results from './Result';

import Header from './Header';

// Actions
import { fetchVariantProducts } from 'src/actions/mgmtVariantAction';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: 100
  }
}));

function VariantListView() {

  const dispatch = useDispatch();

  const classes = useStyles();

  const businessInfo = useSelector(
    (state) => state?.app?.businessInfo
  );

  const customerId = businessInfo?.customerId;

  // Fetch Data
  useEffect(() => {

    if (customerId) {

      dispatch(
        fetchVariantProducts(customerId)
      );

    }

  }, [customerId]);

  // No Customer
  if (!customerId) {

    return null;

  }

  return (

    <Page
      className={classes.root}
      title="Variant Product List"
    >

      <Header />

      <Container maxWidth={false}>

        <br />

        {/* Customer Card */}
        <Grid>

          <Card style={{ maxHeight: "400px" }}>

            <CardContent>

              <Grid
                className="row"
                container
                spacing={2}
              >

                {/* Customer Id */}
                <Grid item xs={5}>

                  <TextField
                    fullWidth
                    label="Customer Id"
                    name="customerId"
                    value={customerId}
                    variant="outlined"
                  />

                </Grid>

              </Grid>

            </CardContent>

          </Card>

        </Grid>

        <br />

        {/* Results Table */}
        <Results
          customerId={customerId}
        />

        <br /><br />

      </Container>

    </Page>

  );
}

export default VariantListView;